.textAreaStyle {
    font-size: var(--mantine-font-size-sm);
    background: var(--mantine-color-dark-5);
    border: 1px solid var(--mantine-color-dark-3);
}

.footerBox {
    width: 100%;
    height: var(--customer-panel-bottom-control-footer-height);
    position: sticky;
    bottom: 0;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 var(--mantine-radius-md) var(--mantine-radius-md);
    padding: var(--mantine-spacing-sm);

    @media (max-width: $mantine-breakpoint-lg) {
        padding: var(--mantine-spacing-xs);
    }

    @media (max-width: $mantine-breakpoint-md) {
        padding: var(--mantine-spacing-3xs);
    }
}

.linkHelpButton {
    &[data-variant="transparent"] {
        &:hover {
            background-color: transparent;
            color: var(--mantine-color-dark-3);
        }
    }
    color: var(--mantine-color-dark-2);
}
